import StepVerifyErrorTracking from "../../../../contents/docs/error-tracking/installation/_snippets/step-verify-error-tracking.mdx";
import StepUploadSymbolSets from "../../../../contents/docs/error-tracking/installation/_snippets/step-upload-symbol-sets.tsx";
import * as React from 'react';
export default {
  StepVerifyErrorTracking,
  StepUploadSymbolSets,
  React
};